import {FormikErrors} from 'formik';
import {set} from 'lodash';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {RECOMMENDATION_SUBTYPE_TO_SERVER} from '../../../constants/SolutionType';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import {cleanForCuro} from '../../../utils/cleanString';
import {
  getPotContactId,
  getIsMinor,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
} from './helpers';
import validateUUID from '../../../utils/validateUUID';
import {SaltusAny} from '../../../utils/SaltusAny';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';

export const getActionVariables = async ({
  accountId,
  goalId,
  ovrecommendId,
  values,
  contacts = [],
}: updateRecsVarsProps): Promise<UpsertOvrecommendVariables> => {
  const {contact, urgency, urgencyReason, action} = values;
  const isMinor = getIsMinor(contact, contacts);

  return {
    action: OVRecommendActionEnum.ACTION,
    solutionType: RECOMMENDATION_SUBTYPE_TO_SERVER.ACTION_BASED,
    ovrecommendId: validateUUID(ovrecommendId),
    accountId: validateUUID(accountId),
    goalId: validateUUID(goalId),
    contactId: getPotContactId(contact, isMinor),
    urgency,
    urgencyReason,
    note: cleanForCuro(action?.note) || '',
  };
};

export const generateActionOVRPots = async ({
  accountId,
}: updateRecommendPotsVariables) => {
  // do nothing
};

export const actionValidator = (
  values: recommendFieldsType,
  errors: SaltusAny
): FormikErrors<recommendFieldsType> => {
  if (!values.goal?.id) {
    if (!values.isSppDa) {
      errors.goal = 'Please select a goal';
    }
  }
  if (!values.action?.note) {
    set(errors, 'action.note', 'A note is required');
  }
  return errors;
};
